import { CustomFormattedMessage } from '../../../i18n/i18n';
import Select from '@rio-cloud/rio-uikit/Select';
import React from 'react';
import {
  getFromFilter,
  getPeriodFilter,
  getToFilter,
  setFrom,
  setPeriod,
  setServiceTypes,
  setTo,
  useDashboardFilteredTransactions,
} from '../../../state/transactions/transactionFilterSlice';
import { useAppDispatch, useAppSelector } from '../../../state/hooks';
import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import {
  usePeriodSelectOptions,
  parsePeriod,
} from '../../../usePeriodSelectOptions';
import moment from 'moment';
import { ServiceType } from '../../../codegen/transactions';
import { DateFilterPicker } from '../../../components/DateFilterPicker';

export const FilterBar: React.FC = () => {
  const dispatch = useAppDispatch();
  const { serviceTypeOptions } = useDashboardFilteredTransactions();
  const from = moment(useAppSelector(getFromFilter));
  const to = moment(useAppSelector(getToFilter));
  const period = useAppSelector(getPeriodFilter);
  const { transactionFilterPeriods } = usePeriodSelectOptions();

  return (
    <TableToolbar>
      <div className="table-toolbar-container ">
        <div className="table-toolbar-group-left justify-content-center">
          <div className="table-toolbar-column">
            <div className="btn-toolbar table-btn-toolbar">
              <DateFilterPicker
                labelId={'common.startDate'}
                value={from}
                onChange={(d) => dispatch(setFrom(d))}
                isDateBlocked={(d) => d.isAfter(to, 'day')}
                errorMessageId={(d) =>
                  d.isAfter(to, 'day') && 'common.timerange.beforeEndDate'
                }
                data-testid={'dashboard-filter-bar-start-date-picker'}
              />
            </div>
          </div>
          <div className="table-toolbar-column">
            <div className="btn-toolbar table-btn-toolbar">
              <DateFilterPicker
                labelId={'common.endDate'}
                value={to}
                onChange={(d) => dispatch(setTo(d))}
                isDateBlocked={(d) => d.isBefore(from, 'day')}
                errorMessageId={(d) =>
                  (d.isBefore(from, 'day') &&
                    'common.timerange.afterStartDate') ||
                  (d.isAfter(moment(), 'day') &&
                    'common.timerange.beforeFuture')
                }
                data-testid={'dashboard-filter-bar-end-date-picker'}
              />
            </div>
          </div>
          <div className="table-toolbar-column">
            <div className="btn-toolbar table-btn-toolbar">
              <div data-testid={'dashboard-filter-bar-period-selector'}>
                <label>
                  <CustomFormattedMessage id={'common.period'} />
                </label>
                <Select
                  useClear
                  className={'width-200'}
                  id={'periodSelector'}
                  placeholder={
                    <CustomFormattedMessage id={'common.selectPeriod'} />
                  }
                  options={transactionFilterPeriods}
                  onChange={(option) => {
                    const value = option ? parsePeriod(option.id) : undefined;
                    dispatch(setPeriod(value));
                  }}
                  value={period ? [period.toString()] : []}
                />
              </div>
            </div>
          </div>
          <div className="table-toolbar-column">
            <div className="btn-toolbar table-btn-toolbar gap-5">
              <div data-testid={'dashboard-filter-bar-service-types-selector'}>
                <label className="min-width-300">
                  <CustomFormattedMessage id={'common.services'} />
                </label>
                <Multiselect
                  placeholder={
                    <CustomFormattedMessage
                      id={'common.filter.serviceFilter.placeholder'}
                    />
                  }
                  options={serviceTypeOptions}
                  onChange={(options: string[]) =>
                    dispatch(setServiceTypes(options as ServiceType[]))
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TableToolbar>
  );
};
